"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var layout_1 = require("../../viewUtils/layout");
var utils_1 = require("../utils");
var turtle_1 = require("./turtle");
var GREED_STEP = 150;
var GraphBuilder = /** @class */ (function () {
    function GraphBuilder(dataProvider) {
        this.dataProvider = dataProvider;
    }
    GraphBuilder.prototype.createGraph = function (graph) {
        var _this = this;
        return this.dataProvider.elementInfo({ elementIds: graph.elementIds }).then(function (elementsInfo) { return ({
            preloadedElements: elementsInfo,
            layoutData: _this.getLayout(graph.elementIds, graph.links),
        }); });
    };
    GraphBuilder.prototype.getGraphFromRDFGraph = function (graph) {
        var _a = this.getGraphElements(graph), elementIds = _a.elementIds, links = _a.links;
        return this.createGraph({ elementIds: elementIds, links: links });
    };
    GraphBuilder.prototype.getGraphFromTurtleGraph = function (graph) {
        var _this = this;
        return turtle_1.parseTurtleText(graph).then(function (triples) { return _this.getGraphFromRDFGraph(triples); });
    };
    GraphBuilder.prototype.getGraphElements = function (response) {
        var elements = {};
        var links = [];
        for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
            var _a = response_1[_i], subject = _a.subject, predicate = _a.predicate, object = _a.object;
            if (subject.type === 'uri' && !elements[subject.value]) {
                elements[subject.value] = true;
            }
            if (object.type === 'uri' && !elements[object.value]) {
                elements[object.value] = true;
            }
            if (subject.type === 'uri' && object.type === 'uri') {
                links.push({
                    linkTypeId: predicate.value,
                    sourceId: subject.value,
                    targetId: object.value,
                });
            }
        }
        return { elementIds: Object.keys(elements), links: links };
    };
    GraphBuilder.prototype.getLayout = function (elementsIds, linksInfo) {
        var rows = Math.ceil(Math.sqrt(elementsIds.length));
        var grid = layout_1.uniformGrid({ rows: rows, cellSize: { x: GREED_STEP, y: GREED_STEP } });
        var layoutElements = elementsIds.map(function (id, index) {
            var _a = grid(index), x = _a.x, y = _a.y;
            return { type: 'element', id: "element_" + utils_1.generate64BitID(), iri: id, position: { x: x, y: y } };
        });
        var layoutElementsMap = lodash_1.keyBy(layoutElements, 'iri');
        var layoutLinks = [];
        linksInfo.forEach(function (link, index) {
            var source = layoutElementsMap[link.sourceId];
            var target = layoutElementsMap[link.targetId];
            if (!source || !target) {
                return;
            }
            layoutLinks.push({
                type: 'link',
                id: "link_" + utils_1.generate64BitID(),
                typeId: link.linkTypeId,
                source: { id: source.id },
                target: { id: target.id },
            });
        });
        return { cells: layoutElements.concat(layoutLinks) };
    };
    return GraphBuilder;
}());
exports.GraphBuilder = GraphBuilder;
exports.default = GraphBuilder;
